import { hasStandardSpecificDefinition } from "../../../../../../../utils";
import { Column, Gallery, Row } from "../../../../../../../widget";
import { BasicDetailsSection } from "../BasicDetailsSection";
import { StandardSpecificSection } from "../StandardSpecificSection";
import { usePreAccessOverviewTab } from "./usePreAccessOverviewTab";

// Read-only, so the details section never asks to change anything.
const noop = (): void => undefined;

/** The project's public overview, for a user who cannot read the project. */
export const PreAccessOverviewTab = (): JSX.Element => {
  const {
    publicProjectDetails,
    basicDetailsData,
    locationData,
    validatorData,
    isNoStandard,
    standardSpecificDefinition,
    images,
    videoUrl,
    longDescription,
  } = usePreAccessOverviewTab();

  return (
    <>
      <div className="ProjectTabSection">
        <Row spacingV="ml">
          <Column span={12}>
            <h2>About the project</h2>
          </Column>
        </Row>
        {longDescription && (
          <Row spacingV="xl">
            <Column span={12}>
              <p className="body1">{longDescription}</p>
            </Column>
          </Row>
        )}
        {images && images.length > 0 && (
          <Row spacingV="ll">
            <Column span={12}>
              <Gallery imageSources={images} videoUrl={videoUrl} corners="rounded" />
            </Column>
          </Row>
        )}
        <Row spacingV="ml">
          <Column span={12}>
            <h2>Details</h2>
          </Column>
        </Row>
        {publicProjectDetails && (
          <BasicDetailsSection
            projectDetails={publicProjectDetails}
            basicDetailsData={basicDetailsData}
            setBasicDetailsData={noop}
            locationData={locationData}
            isReadOnly
            validatorData={validatorData}
            isNoStandard={isNoStandard}
          />
        )}
      </div>
      {standardSpecificDefinition && hasStandardSpecificDefinition(standardSpecificDefinition) && (
        <div className="ProjectTabSection">
          <StandardSpecificSection
            standardSpecificDefinition={standardSpecificDefinition}
            hasWriteProjectDetailsPermission={false}
            centerTextHidden={false}
          />
        </div>
      )}
    </>
  );
};
